<template>
  <div class="foot-con">
    <div class="content">
        <div class="lab-group">
            <label class="fs24">客服电话</label>
            <label class="fs50 mar-top-40">{{ phone }}</label>
            <label class="col-ccc fs28 mar-top-10">{{ time }}</label>
            <div class="consult mar-top-40">咨询客服</div>
        </div>
        <div class="verticalline"></div>
    </div>
    <div class="foot-box">
      <span style="font-family:arial;">&copy; </span>2026 绵阳市道贤居商务信息咨询有限公司 | 电话：<a href="tel:15102802164" style="color:#ccc">15102802164</a> | 地址：四川省绵阳市涪城区科技城软件产业园E区FH-24号
      <br/>
      <a href="javascript:;" @click="showAgreement = true" style="color:#ccc">用户服务协议</a> | <a href="javascript:;" @click="showPrivacy = true" style="color:#ccc">隐私政策</a> | <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#ccc">蜀ICP备2026026681号-1</a>
    </div>

    <el-dialog title="用户服务协议" :visible.sync="showAgreement" width="680px" append-to-body>
      <div class="agreement-content">
        <h4>引言</h4>
        <p>欢迎您使用绵阳市道贤居商务信息咨询有限公司的在线商城服务平台。</p>
        <p>我司的在线商城平台（以下简称"我平台"）根据《用户服务协议》（以下简称"本协议"）及其他补充协议为您提供服务。</p>
        <p>您在使用我平台服务前请务必审慎阅读、充分理解本协议及补充协议各条款内容，特别是免除或者限制责任的条款、对用户权利进行限制的条款等。</p>
        <p>我平台有权根据实际经营情况、国家相关法律法规的调整，调整本协议的任何条款或增加其他的补充协议。补充协议与本协议具有相同的法律效力。</p>
        <p>除非您已充分阅读、完全理解并接受本协议及补充协议的所有条款，否则您无权使用我平台服务。</p>
        <p>您选择下单购买相关商品的行为或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意签署本协议。</p>
        <h4>一、协议适用范围</h4>
        <p>本协议及补充协议是我平台制定的关于获取我平台服务的相关规则。本规则适用于由我平台提供的所有商品销售服务。</p>
        <h4>二、商品与服务</h4>
        <p>2.1 我平台主营日用品销售，包括毛巾浴巾、清洁用品、洗护用品、抽纸等日常生活用品，均为实体商品，全国包邮。</p>
        <p>2.2 在使用我平台服务时，请务必提供真实的个人信息和收货地址，若您提供的信息有误，可能影响商品配送。我们保证您的所有个人信息仅用于订单处理和商品发货，不会用于其他用途。</p>
        <p>2.3 目前，我平台不会主动共享或转让您的个人信息至我们以外的第三方，如存在其他共享或转让情形时，我们会征得您的明示同意。</p>
        <h4>三、发货与售后</h4>
        <p>3.1 我平台承诺在订单支付成功后48小时内发货，全国包邮（偏远地区除外）。</p>
        <p>3.2 如商品存在质量问题，支持签收7天内退换，退换运费由我方承担。</p>
        <h4>四、免责声明</h4>
        <p>4.1 本平台与其他互联网平台一样，可能受到网络安全和网络故障问题的影响，由此可能给您造成损失的，本平台无须承担责任。</p>
        <p>4.2 商品图片仅供参考，请以收到的实物为准。我平台不对商品图片与实物的细微色差承担责任。</p>
      </div>
    </el-dialog>

    <el-dialog title="隐私政策" :visible.sync="showPrivacy" width="680px" append-to-body>
      <div class="agreement-content">
        <p>绵阳市道贤居商务信息咨询有限公司及商城平台（以下简称我平台）非常重视保护您的个人隐私。</p>
        <p>为向您提供商品销售及配送服务，我平台可能会收集和使用您的相关信息。其中要点如下：</p>
        <h4>一、信息收集范围</h4>
        <p>1.1 在您下单购买商品时，我平台需要获取您的姓名、手机号和收货地址，用于商品配送和订单联系。</p>
        <p>1.2 我平台建议您提供真实的个人信息，若您提供的信息有误，可能影响商品配送。</p>
        <h4>二、信息的存储</h4>
        <p>我平台会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。</p>
        <p>一般而言，我平台仅为实现目的所必需的时间保留您的个人信息。当我平台停止运营时，我平台将以通知等形式告知您，并在合理期限内删除或匿名化处理您的个人信息。本平台服务器位于中华人民共和国境内，我们不会将您的个人信息传输至境外。</p>
        <h4>三、信息安全</h4>
        <p>我平台努力为用户的信息安全提供保障，使用加密技术、匿名化处理等手段保护您的个人信息。</p>
        <h4>四、信息的使用</h4>
        <p>我平台收集的信息仅用于订单处理和商品配送。如超出收集时所声称的目的范围使用，我平台将再次征得您的明示同意。</p>
        <h4>五、信息共享</h4>
        <p>除按法律法规规定外，我平台不会主动对外公开披露所收集的个人信息。如须公开披露时，我平台会征得您的明示同意。</p>
        <h4>六、隐私政策的更新</h4>
        <p>我平台可能会适时对本声明进行修订。当条款发生变更时，将会在网页重要位置提示修改内容。</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
    export default {
        name: 'v-foot',
        props: {
            obj: Object
        },
        data () {
            return {
                phone: '15102802164',
                time: '9:00-23:00',
                showAgreement: false,
                showPrivacy: false
            }
        },
        watch: {
            obj: {
                handler (nVal, oVal) {
                    var data = nVal.componentContent.publicList
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].title === '客服电话') { this.phone = data[i].des }
                        if (data[i].title === '营业时间') { this.time = data[i].des }
                    }
                }
            }
        }
    }
</script>
<style scoped lang="scss">
.foot-con{
    height: 454px;
    min-width: 1440px;
    background-color: #333333;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .content{
        display: flex;
        // width: 60%;
        // justify-content: space-between;
        width: 1240px;
        justify-content: space-around;
        .lab-group{
            display: flex;
            flex-direction: column;
            label{
                font-weight: 400;
            }
            .consult{
                width: 164px;
                height: 50px;
                color: #cccccc;
                border: 1px #cccccc solid;
                line-height: 50px;
                text-align: center;
                cursor: pointer;
            }
        }
        .verticalline{
            height: 238px;
            width: 1px;
            background-color:#666666;
        }
    }
}
.foot-box{
    margin-top: 30px;
    text-align: center;
    font-size: 12px;
    line-height: 2;
    a {
        color: #ccc;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
}
.agreement-content {
    max-height: 60vh;
    overflow-y: auto;
    h4 {
        margin: 16px 0 6px;
        font-size: 14px;
        color: #1d2129;
    }
    h4:first-child {
        margin-top: 0;
    }
    p {
        margin-bottom: 8px;
        font-size: 13px;
        color: #86909c;
        line-height: 1.8;
        text-align: justify;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/v-foot.vue